import { render } from "./ChatModal.vue?vue&type=template&id=85759884&scoped=true"
import script from "./ChatModal.vue?vue&type=script&lang=js"
export * from "./ChatModal.vue?vue&type=script&lang=js"

import "./ChatModal.vue?vue&type=style&index=0&id=85759884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85759884"]])

export default __exports__